import React from 'react';
import {Navigate, useParams} from 'react-router-dom';
import {DashboardView} from './DashboardView';
import {OnboardingView} from './components/OnboardingView';

export const DashboardPage = ({ darkMode }) => {
  return <DashboardView darkMode={darkMode} />;
};